import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "#A2001D",
  d: "M20 0C11.4 0 4.07 5.428 1.244 13.043h37.512C35.93 5.428 28.6 0 20 0Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "M20 40c8.6 0 15.93-5.428 18.756-13.044H1.244C4.07 34.572 11.401 40 20 40Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#496E2D",
  d: "M15.217 18.696h-3.855a1.74 1.74 0 0 1 1.681-1.305v-2.608a4.353 4.353 0 0 0-4.347 4.347v2.174h6.521c.24 0 .435.196.435.435v.87H6.956v2.608h11.305V21.74a3.047 3.047 0 0 0-3.044-3.043Zm6.523 3.913v-7.826h-2.61v10.435h4.348v-2.61H21.74Zm8.695 0v-7.826h-2.609v7.826h-.87V20h-2.608v5.218h7.826v-2.61h-1.74Z"
}, null, -1), i = [
  h,
  n,
  c,
  s
];
function d(v, _) {
  return e(), l("svg", o, [...i]);
}
const r = { render: d };
export {
  r as default,
  d as render
};
